import Swal from "sweetalert2";

const NavigationAlert = ({ confirmNavigation, cancelNavigation }) => {
  Swal.fire({
     html: '<span style="font-size:20px;">Are you sure you want to leave this page? Any unsaved changes will be lost</span>',
    // title: document.getElementById("custom-alert-title"),
    customClass: {
      container: "custom-alert-container",
      header: "custom-alert-header",
      title: "custom-alert-title",
      cancelButton: "alert-cancel",
      confirmButton: "alert-confirm",
    },

    showCloseButton: true,
    isconfirmed: "",
    icon: "question",
    confirmButtonText: "Ok",
    confirmButtonColor: "#20409A",
    cancelButtonColor: "#fff",
    // inputValue: ,
    showCancelButton: true,
    iconColor: "#20409A",
  }).then((result) => {
    if (result.isConfirmed) {
      if (confirmNavigation) confirmNavigation();
      
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      if (cancelNavigation) cancelNavigation();
    }
  });
};

export default NavigationAlert;
